"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Business = _interopRequireDefault(require("../model/Business"));
var _Customer = _interopRequireDefault(require("../model/Customer"));
var _Employee = _interopRequireDefault(require("../model/Employee"));
var _Group = _interopRequireDefault(require("../model/Group"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _Operator = _interopRequireDefault(require("../model/Operator"));
var _OperatorLevel = _interopRequireDefault(require("../model/OperatorLevel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* OrganizationOperator service.
* @module api/OrganizationOperatorApi
* @version 3.0
*/
var OrganizationOperatorApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new OrganizationOperatorApi. 
  * @alias module:api/OrganizationOperatorApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OrganizationOperatorApi(apiClient) {
    _classCallCheck(this, OrganizationOperatorApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create a new Operator Employee
   * Create a new Employee for the Operator.
   * @param {Number} operatorId ID of the operator
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Employee} and HTTP response
   */
  return _createClass(OrganizationOperatorApi, [{
    key: "createOperatorEmployeeWithHttpInfo",
    value: function createOperatorEmployeeWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling createOperatorEmployee");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Employee["default"];
      return this.apiClient.callApi('/operators/{operatorId}/employees', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Operator Employee
     * Create a new Employee for the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Employee}
     */
  }, {
    key: "createOperatorEmployee",
    value: function createOperatorEmployee(operatorId) {
      return this.createOperatorEmployeeWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a new Operator Level
     * Create a new Level for the Operator.
     * @param {Number} operatorId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OperatorLevel} and HTTP response
     */
  }, {
    key: "createOperatorLevelWithHttpInfo",
    value: function createOperatorLevelWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling createOperatorLevel");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OperatorLevel["default"];
      return this.apiClient.callApi('/operators/{operatorId}/levels', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Operator Level
     * Create a new Level for the Operator.
     * @param {Number} operatorId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OperatorLevel}
     */
  }, {
    key: "createOperatorLevel",
    value: function createOperatorLevel(operatorId) {
      return this.createOperatorLevelWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a new Operator Level
     * Create a new Level underneath the selected Operator Level.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OperatorLevel} and HTTP response
     */
  }, {
    key: "createOperatorSubLevelWithHttpInfo",
    value: function createOperatorSubLevelWithHttpInfo(operatorId, levelId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling createOperatorSubLevel");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling createOperatorSubLevel");
      }
      var pathParams = {
        'operatorId': operatorId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OperatorLevel["default"];
      return this.apiClient.callApi('/operators/{operatorId}/levels/{levelId}/levels', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Operator Level
     * Create a new Level underneath the selected Operator Level.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OperatorLevel}
     */
  }, {
    key: "createOperatorSubLevel",
    value: function createOperatorSubLevel(operatorId, levelId) {
      return this.createOperatorSubLevelWithHttpInfo(operatorId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operators details
     * Gets the details for the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Operator} and HTTP response
     */
  }, {
    key: "getOperatorWithHttpInfo",
    value: function getOperatorWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperator");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Operator["default"];
      return this.apiClient.callApi('/operators/{operatorId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operators details
     * Gets the details for the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Operator}
     */
  }, {
    key: "getOperator",
    value: function getOperator(operatorId) {
      return this.getOperatorWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator's Businesses
     * Gets all the Businesses which are owned by the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Business>} and HTTP response
     */
  }, {
    key: "getOperatorBusinessesWithHttpInfo",
    value: function getOperatorBusinessesWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorBusinesses");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Business["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/businesses', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator's Businesses
     * Gets all the Businesses which are owned by the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Business>}
     */
  }, {
    key: "getOperatorBusinesses",
    value: function getOperatorBusinesses(operatorId) {
      return this.getOperatorBusinessesWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator's Customers
     * Gets all the Customers who are managed by the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Customer>} and HTTP response
     */
  }, {
    key: "getOperatorCustomersWithHttpInfo",
    value: function getOperatorCustomersWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorCustomers");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Customer["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/customers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator's Customers
     * Gets all the Customers who are managed by the Operator.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Customer>}
     */
  }, {
    key: "getOperatorCustomers",
    value: function getOperatorCustomers(operatorId) {
      return this.getOperatorCustomersWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator's Employees
     * Gets all of the Operator's Employees
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Employee>} and HTTP response
     */
  }, {
    key: "getOperatorEmployeesWithHttpInfo",
    value: function getOperatorEmployeesWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorEmployees");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Employee["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/employees', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator's Employees
     * Gets all of the Operator's Employees
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Employee>}
     */
  }, {
    key: "getOperatorEmployees",
    value: function getOperatorEmployees(operatorId) {
      return this.getOperatorEmployeesWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator's Groups
     * Gets all the Groups which are part of the Operator's hierarchy.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Group>} and HTTP response
     */
  }, {
    key: "getOperatorGroupsWithHttpInfo",
    value: function getOperatorGroupsWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorGroups");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Group["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/groups', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator's Groups
     * Gets all the Groups which are part of the Operator's hierarchy.
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Group>}
     */
  }, {
    key: "getOperatorGroups",
    value: function getOperatorGroups(operatorId) {
      return this.getOperatorGroupsWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator Level details
     * Gets the details for the selected Level under the Operator.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OperatorLevel} and HTTP response
     */
  }, {
    key: "getOperatorLevelWithHttpInfo",
    value: function getOperatorLevelWithHttpInfo(operatorId, levelId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorLevel");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getOperatorLevel");
      }
      var pathParams = {
        'operatorId': operatorId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OperatorLevel["default"];
      return this.apiClient.callApi('/operators/{operatorId}/levels/{levelId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator Level details
     * Gets the details for the selected Level under the Operator.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OperatorLevel}
     */
  }, {
    key: "getOperatorLevel",
    value: function getOperatorLevel(operatorId, levelId) {
      return this.getOperatorLevelWithHttpInfo(operatorId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator Level Employees
     * Gets all the Employees at that Level for the Operator.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Employee>} and HTTP response
     */
  }, {
    key: "getOperatorLevelEmployeesWithHttpInfo",
    value: function getOperatorLevelEmployeesWithHttpInfo(operatorId, levelId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorLevelEmployees");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getOperatorLevelEmployees");
      }
      var pathParams = {
        'operatorId': operatorId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Employee["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/levels/{levelId}/employees', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator Level Employees
     * Gets all the Employees at that Level for the Operator.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Employee>}
     */
  }, {
    key: "getOperatorLevelEmployees",
    value: function getOperatorLevelEmployees(operatorId, levelId) {
      return this.getOperatorLevelEmployeesWithHttpInfo(operatorId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator Level's levels
     * Gets all the Levels which are under the specified Operator’s Level.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/OperatorLevel>} and HTTP response
     */
  }, {
    key: "getOperatorLevelSubLevelsWithHttpInfo",
    value: function getOperatorLevelSubLevelsWithHttpInfo(operatorId, levelId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorLevelSubLevels");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getOperatorLevelSubLevels");
      }
      var pathParams = {
        'operatorId': operatorId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_OperatorLevel["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/levels/{levelId}/levels', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator Level's levels
     * Gets all the Levels which are under the specified Operator’s Level.
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/OperatorLevel>}
     */
  }, {
    key: "getOperatorLevelSubLevels",
    value: function getOperatorLevelSubLevels(operatorId, levelId) {
      return this.getOperatorLevelSubLevelsWithHttpInfo(operatorId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Operator's Levels
     * Gets all of the Operator's Levels
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/OperatorLevel>} and HTTP response
     */
  }, {
    key: "getOperatorLevelsWithHttpInfo",
    value: function getOperatorLevelsWithHttpInfo(operatorId) {
      var postBody = null;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling getOperatorLevels");
      }
      var pathParams = {
        'operatorId': operatorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_OperatorLevel["default"]];
      return this.apiClient.callApi('/operators/{operatorId}/levels', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Operator's Levels
     * Gets all of the Operator's Levels
     * @param {Number} operatorId ID of the operator
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/OperatorLevel>}
     */
  }, {
    key: "getOperatorLevels",
    value: function getOperatorLevels(operatorId) {
      return this.getOperatorLevelsWithHttpInfo(operatorId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Operators
     * Gets a list of all the Operators in the system.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Operator>} and HTTP response
     */
  }, {
    key: "getOperatorsWithHttpInfo",
    value: function getOperatorsWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Operator["default"]];
      return this.apiClient.callApi('/operators', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Operators
     * Gets a list of all the Operators in the system.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Operator>}
     */
  }, {
    key: "getOperators",
    value: function getOperators() {
      return this.getOperatorsWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a level.
     * Modify the details of a level. <br>If the parentlevelId is given in the body of the PUT then the Level will move to that parent level.<br>
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @param {module:model/OperatorLevel} operatorLevel Level details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OperatorLevel} and HTTP response
     */
  }, {
    key: "modifyBusinessLevel1WithHttpInfo",
    value: function modifyBusinessLevel1WithHttpInfo(operatorId, levelId, operatorLevel) {
      var postBody = operatorLevel;
      // verify the required parameter 'operatorId' is set
      if (operatorId === undefined || operatorId === null) {
        throw new Error("Missing the required parameter 'operatorId' when calling modifyBusinessLevel1");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling modifyBusinessLevel1");
      }
      // verify the required parameter 'operatorLevel' is set
      if (operatorLevel === undefined || operatorLevel === null) {
        throw new Error("Missing the required parameter 'operatorLevel' when calling modifyBusinessLevel1");
      }
      var pathParams = {
        'operatorId': operatorId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _OperatorLevel["default"];
      return this.apiClient.callApi('/operators/{operatorId}/levels/{levelId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a level.
     * Modify the details of a level. <br>If the parentlevelId is given in the body of the PUT then the Level will move to that parent level.<br>
     * @param {Number} operatorId ID of the operator
     * @param {Number} levelId ID of the level
     * @param {module:model/OperatorLevel} operatorLevel Level details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OperatorLevel}
     */
  }, {
    key: "modifyBusinessLevel1",
    value: function modifyBusinessLevel1(operatorId, levelId, operatorLevel) {
      return this.modifyBusinessLevel1WithHttpInfo(operatorId, levelId, operatorLevel).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();